import { getActivityDetail, receiveReward } from '@/api'
import { useUserInfo, useActivityList } from '@/store'
import type { iActivity, iFlowType } from '@/types/index'
// import showLoginOrReg from '@a/components/showLoginOrRegPopup'
import { ACTIVITY_TYPES } from '@/consts'

type AtLeastOne<T, U = {[K in keyof T]: Pick<T, K>}> = Partial<T> & U[keyof U];

export const getDetail = async (activityId: string, fn: (args: any) => Promise<any>) => {
  const { code, data } = await fn({
    activityId
  }).catch(() => ({code: 0, data: null}))
  if (code == 1 && data) return data
  return null
}

export const getReceberParams: (item: iActivity) => iReceber = (item) => {
  return {
    flowType: item.flowType,
    activityId: item.activityId,
    rewardId: [ACTIVITY_TYPES.DepositReward, ACTIVITY_TYPES.TreasureBox, ACTIVITY_TYPES.MysteryBonus].includes(item.activityType) ? item.id : undefined
  }
}

interface iReceber {
  flowType: iFlowType,
  activityId: string,
  rewardId?: string
}

export const receber = async ({ flowType, activityId, rewardId }: iReceber) => {
  // if (!useUserInfo().isLoggedin) {
  //   showLoginOrReg()
  //   return Promise.reject('please login')
  // }

  showLoadingToast('loading...');
  const res = await receiveReward({
    flowType,
    activityId,
    rewardId
  }).catch(() => ({code: 0, data: null}))

  if (res.code == 1) {
    showSuccessToast({
      message: 'sucesso',
      iconSize: 30
    })

    useActivityList().init()
    return res.data
  } else {
    // showToast(res.msg)
    return Promise.reject(res.data)
  }
}

type iUseActivity = (activityId: string, {
  getInfo, getInfoWithoutAuth
}: AtLeastOne<{
  getInfo: (args: any) => Promise<any>
  getInfoWithoutAuth: (args: any) => Promise<any>
}>) => {
  data: Ref<iActivityData>
  receber: (args: iReceber) => any
  getDetail: (activityId: string, fn: (args: any) => Promise<any>) => Promise<any>
}

interface iActivityData {
  info: any
  detail: any
  descList: string[]
}

export const useActivity: iUseActivity = function(activityId, {
  getInfo, getInfoWithoutAuth
}) {
  const data = ref({
    info: null,
    detail: {
      activityConfigName: '',
      activityConfigDesc: '',
      activityConfigLogo: '',
    },
    descList: []
  })

  const fn = getInfo && getInfoWithoutAuth ?
    (useUserInfo().isLoggedin ? getInfo : getInfoWithoutAuth) :
    (getInfo || getInfoWithoutAuth)

  if (activityId) {
    showLoadingToast('loading...');
    Promise.all([
      getDetail(activityId, fn as (args: any) => Promise<any>),
      getDetail(activityId, getActivityDetail)
    ])
    .then(([info, detail]) => {
      closeToast()
      data.value.info = info
      data.value.detail = detail
      data.value.descList = detail.activityConfigDesc?.split('\n').map(s => s.trim()) || [];
    })
  } else {
    showToast({
      message: 'Invalid activityId',
      duration: 0,
    })
  }

  return {
    data,
    receber: (args: iReceber) => {
      receber(args)
        .then(() => getDetail(activityId, fn as (args: any) => Promise<any>))
        .then(info => {
          data.value.info = info
        })
        .catch(err => {
          console.error(err)
        })
    },
    getDetail
  }
}
